<stx-generic-page>
  @switch (errType) { @case (errorTypeEnum.URL_NOT_FOUND) {
  <h1>{{ 'error.url_not_found' | translate }}</h1>
  } @case (errorTypeEnum.RESOURCE_NOT_FOUND) {
  <h1>{{ 'error.resource_not_found' | translate }}</h1>
  } }
</stx-generic-page>
